export default function Features() {
  const features = [
    {
      icon: "ri-hd-line",
      title: "高清画质",
      desc: "1080P超清画质，影院级观影体验，支持多清晰度切换",
    },
    {
      icon: "ri-speed-up-line",
      title: "极速加载",
      desc: "全球CDN加速，秒开不卡顿，流畅观影无等待",
    },
    {
      icon: "ri-smartphone-line",
      title: "多端适配",
      desc: "电脑、平板、手机全平台支持，随时随地想看就看",
    },
    {
      icon: "ri-shield-check-line",
      title: "免费安全",
      desc: "完全免费无需注册，无广告干扰，安全绿色观影环境",
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            为什么选择麻花影院
          </h2>
          <p className="text-sm text-foreground-500 mt-2">致力于提供极致的免费观影体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl bg-background-50 hover:bg-primary-500 cursor-default transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-background-50/20 group-hover:text-background-50 mb-4 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 group-hover:text-background-50 transition-colors mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}